<template>
<div class="file-manage-view">
        <div class="file-manage-content">
            <div class="file-manage-center" ref="ManageCenter">
                <div class="file-manage-worker-item" v-for="(item, index) in memberList">
                    <div class="worker-avatar">
                        <div v-if="
                                item.toType === 'PERSON' &&
                                    fileAvatar(item) === ''
                            " class="user-avatar" :style="avatarColorStye(item.toName)">
                            <div class="user-name">
                                {{ userName(item.toName) }}
                            </div>
                        </div>
                        <img v-else :src="fileAvatar(item)"/>
                    </div>
                    <div class="worker-info">
                        <div class="worker-title">
                            <div v-if="item.toName?.length < 5" class="worker-name" :style="
userInfo.spaceId !== item.toSpace &&
item.toName !== $t('知识库管理员') ?
'' :
'margin-right: 0px;'">
                                {{ spliceMemberName(item) }}
                            </div>
                            <a-tooltip v-else :content="item.toName" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                                <div class="worker-name" :style="
userInfo.spaceId !== item.toSpace &&
item.toName !== $t('知识库管理员') ||
item.toType === 'APP' ?
'' :
'margin-right: 0px;'">
                                    {{ spliceMemberName(item) }}
                                </div>
                            </a-tooltip>
                            <div v-if="
userInfo.spaceId !== item.toSpace &&
item.toName !== $t('知识库管理员') &&
item.toType !== 'APP'" class="worker-space-name">
                                @{{ item.toSpaceName }}
                            </div>
                            <div class="worker-tag" v-if="index === 0">{{$t("所有者")}}                            </div>
                            <div class="worker-tag worker-tag-app" v-if="item.toType === 'APP'">{{$t("应用")}}                            </div>
                            <div v-if="!!item.inherit" class="worker-recover">{{$t("继承于父级文件")}}                            </div>
                        </div>
                        <div class="worker-wiki-role" v-if="
                                index !== 0 &&
                                    (item.memberIdentity === 'ADMIN' ||
                                        item.memberIdentity === 'MEMBER')
                            ">
                            {{ memberIdentity(item) }}
                        </div>
                    </div>
                    <div class="worker-auth-diseditable" v-if="
                            (myAuth !== 'ALL' && myAuth !== 'WRITE') ||
                                (item.edit === false && index === 0) ||
                                item.memberIdentity === 'ADMIN' ||
                                item.edit === false
                        ">
                        {{ authName(item.auth) }}
                    </div>
                    <a-dropdown v-else class="dropdown-auth-editable" trigger="click" position="br" @select="cmd => handlerChangeAuth(item,cmd, index)" @popup-visible-change="(v: boolean) => dropdownMenuVisibleChange(v, index)">
                        <div class="worker-auth-editable" @click="openAuthList(item, index)" @mouseover="mouseAction(index, true)" @mouseleave="mouseAction(index, false)">
                            {{ authName(item.auth) }}
                            <img :src="changeEditableIcon(index)"/>
                        </div>
                        <template #content>
                            <div class="auth-list" v-for="(auth, i) in authList" :key="i">
                                <a-doption :value="i" :divided="
                                        ['ALL', 'RECOVER', 'DELETE'].includes(
                                            auth.id
                                        )
                                    " :disabled="
                                        item.edit === false ||
                                            isDisabledAuth(auth)
                                    ">
                                    <div class="auth-name" :style="computedAuthStyle(auth, item)">
                                        <img v-show="
                                                auth.id === item.auth &&
                                                    !isDisabledAuth(auth)
                                            " src="@/assets/img/share/icon_file_selected.png"/>{{ auth.name }}
                                    </div>
                                    <div class="auth-desc">{{ auth.desc }}</div>
                                </a-doption>
                            </div>
                            <div class="push-message">
                                <span :style="
                                        memberList[index].pushMessage
                                            ? 'color: #222329;'
                                            : 'color: #DDDFE6;'
                                    ">{{$t("修改时发送通知")}}</span>
                                <a-switch class="auth-push-switch" v-model="memberList[index].pushMessage" checked-color="#5C70FF" unchecked-color="#DDDFE6"></a-switch>
                            </div>
                        </template>
                    </a-dropdown>
                    <a-modal class="file-share-common-dialog" v-model:visible="showPushMsgDialog" :simple="true" :footer="false" :render-to-body="false">
                        <div class="content">
                            <div class="title">
                                <img src="@/assets/img/share/icon_file_tip.png"/>{{$t("提示")}}                            </div>
                            <div class="desc">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。")}}                            </div>
                            <div class="bottom">
                                <div class="cancel-btn" @click.stop="
                                        showPushMsgDialog = memberList[
                                            index
                                        ].pushMessage = false
                                    ">{{$t("取消")}}                                </div>
                                <div class="confirm-btn" @click.stop="
                                        modifyAuth(currentCmd, currentIndex)
                                    ">{{$t("确认发送")}}                                </div>
                            </div>
                        </div>
                    </a-modal>
                </div>
                <div class="file-manage-scrollbar" :class="{ hide: !showScrollbar }" ref="scrollbar"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { reactive } from 'vue';
import { deleteAuth, setFileAuth } from '../../core/api/file';
import { AUTH_DETAIL_LIST } from '../../constants/FileShare';
import nameColor from '../../utils/nameColor';
import memberAvatar from '../../utils/avatar';

import EditableSelectedIcon from '@/assets/img/share/icon_file_auth_editable_selected.png';
import EditableHoverIcon from '@/assets/img/share/icon_file_auth_editable_hover.png';
import EditableIcon from '@/assets/img/share/icon_file_auth_editable.png';
import DepartmentAvatar from '@/assets/img/share/icon_file_file.png';
import ManagerAvatar from '@/assets/img/share/icon_file_manager.png';
import GroupAvatar from '@/assets/img/share/fp_user_group.png';
import UnitedDepartmentAvatar from '@/assets/img/share/finder_dept_sub_united.png';
import { mapState } from 'vuex';
import { Modal } from '@toca/arco-design-web-vue';

export default {
  name: 'FileShareManageView',
  props: {
    fileId: {
      type: String },

    myAuth: {
      type: String },

    shareAuthList: {
      type: Array },

    userInfo: {
      type: Object },

    nonAdminMaxAuth: {
      type: String,
      default: '' } },


  data() {
    return {
      memberList: [],
      editableHover: reactive([]),
      editableFocus: reactive([]),
      authList: reactive(AUTH_DETAIL_LIST),
      showScrollbar: false,
      hideScrollbarTimer: null,
      showPushMsgDialog: false,
      currentCmd: null,
      currentIndex: null };

  },
  watch: {
    shareAuthList: {
      handler(v) {
        if (v.length !== 0) {
          let owner = this.shareAuthList[0];
          let filterList = this.shareAuthList.filter(
          (item: any, index: number) => {
            return (
              item.memberIdentity !== 'ADMIN' ||
              index ===
              this.shareAuthList.findIndex(
              (x: any) => x === owner));


          });

          this.memberList = filterList.map((item: any) =>
          item.toType === 'PERSON' ?
          { ...item, pushMessage: true } :
          { ...item, pushMessage: false });

          // const adminItem = {
          //     toName: '知识库管理员',
          //     auth: 'ALL',
          //     edit: false
          // };
          // this.memberList.splice(1, 0, adminItem);
        }
      },
      deep: true,
      immediate: true } },


  computed: {
    ...mapState({
      spaceId: (state) => state.userModule.spaceId }) },


  created() {
    for (let i = 0; i < this.memberList.length; i++) {
      this.editableHover.push(false);
      this.editableFocus.push(false);
    }
  },
  mounted() {
    this.$refs.ManageCenter.addEventListener('scroll', this.onListScroll);
  },
  beforeUnmount() {
    this.$refs.ManageCenter.removeEventListener(
    'scroll',
    this.onListScroll);

    if (this.hideScrollbarTimer) {
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = null;
    }
  },
  emits: ['updateMemberAuthList'],
  methods: {
    isDisabledAuth(auth: any) {
      if (this.nonAdminMaxAuth) {
        const newAuthList = this.authList.filter(
        (i: any) =>
        i.id !== 'NONE' &&
        i.id !== 'DELETE' &&
        i.id !== 'RECOVER');

        const maxAuthIndex = newAuthList.findIndex(
        (i: any) => i.id === this.nonAdminMaxAuth);

        const authIndex = newAuthList.findIndex(
        (i: any) => i.id === auth.id);

        return maxAuthIndex < authIndex;
      } else {
        return false;
      }
    },
    computedAuthStyle(auth: any, item: any) {
      const disabledStyle =
      'color: #CCCED7 !important; margin-left: 36px';
      const activeStyle = 'color: #5C70FF !important';
      const normalStyle = 'color: #222329 !important; margin-left: 36px';
      const specailStyle = 'color: #FF4747 !important; margin-left: 36px';
      const specailActiveStyle = 'color: #FF4747 !important;';

      if (['DELETE', 'NONE'].includes(auth.id)) {
        if (auth.id === item.auth) {
          return specailActiveStyle;
        } else {
          return specailStyle;
        }
      } else {
        const disabled: boolean = this.isDisabledAuth(auth);
        if (disabled) {
          return disabledStyle;
        }
        if (auth.id === item.auth) {
          return activeStyle;
        } else {
          return normalStyle;
        }
      }
    },
    spliceMemberName(item: any) {
      if (!item.toName) {
        return intl.$t("未知用户");
      }
      if (!!item.inherit) {
        return item.toName.length > 10 ?
        item.toName.slice(0, 10) + '...' :
        item.toName;
      } else {
        return item.toName;
      }
    },
    onListScroll() {
      const listEl = this.$refs.ManageCenter;
      const scrollbarEl = this.$refs.scrollbar;

      const scrollTop = listEl.scrollTop;
      const scrollHeight = listEl.scrollHeight;
      const clientHeight = listEl.clientHeight;
      const scrollbarHeight =
      clientHeight * clientHeight / scrollHeight;
      let extraTop: number = 0;
      if (this.myAuth === 'ALL') {
        extraTop = 32 + 8;
      }
      const scrollbarTop =
      scrollTop * clientHeight / scrollHeight + 100 + extraTop;

      // 更新滚动条的高度和位置
      scrollbarEl.style.height = `${scrollbarHeight}px`;
      scrollbarEl.style.top = `${scrollbarTop}px`;

      this.showScrollbar = true;
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = setTimeout(() => {
        this.showScrollbar = false;
      }, 1000);
    },
    authName(auth: string) {
      switch (auth) {
        case 'ALL':
          return intl.$t("所有权限");
        case 'READ':
          return intl.$t("仅查看");
        case 'READ_DOWNLOAD':
          return intl.$t("查看下载");
        case 'WRITE':
          return intl.$t("编辑");
        case 'NONE':
          return intl.$t("无权限");}

    },
    memberIdentity(item: any) {
      switch (item.memberIdentity) {
        case 'ADMIN':
          return intl.$t("知识库管理员");
        case 'MEMBER':
          return intl.$t("知识库成员");}

    },
    changeAuth(command: any, index: number) {
      const fileId = this.fileId;
      if (this.authList[command].id === 'DELETE') {
        /// 删除协作者
        const to = this.memberList[index].to;
        const spaceId = this.memberList[index].toSpace;
        const type = this.memberList[index].toType;
        deleteAuth(to, true, fileId, spaceId, type).
        then((res: any) => {
          const { code, message } = res.data;
          if (code === 200) {
            this.memberList = this.memberList.filter(
            (item: any, i: number) => i !== index);

            this.$emit('updateMemberAuthList');
            this.$message.success(
            this.authList[command].id === 'DELETE' ? intl.$t("移除成功") : intl.$t("恢复成功"));



          } else {
            this.$message.error(
            this.authList[command].id === 'DELETE' ? intl.$t(`移除失败，{message}`, { message: message }) : intl.$t(`恢复失败，{message}`, { message: message }));



          }
        }).
        catch((err) => {
          this.$message.error(
          this.authList[command].id === 'DELETE' ? intl.$t("移除失败") : intl.$t("恢复失败"));



        });
      } else {
        if (this.memberList[index].toType !== 'PERSON') {
          if (this.memberList[index].pushMessage) {
            this.currentCmd = command;
            this.currentIndex = index;
            this.showPushMsgDialog = true;
          } else {
            this.modifyAuth(command, index);
          }
        } else {
          this.modifyAuth(command, index);
        }
      }
    },
    handlerChangeAuth(item: any, command: any, index: number) {
      console.log('------handlerChangeAuth:', command, index, item);
      const selectAuth = this.authList[command].id;
      if (selectAuth === item.auth) return; // 无效操作，选择了相同的权限
      if (item.inheritAuth !== null) {
        const isDeleteAuth = selectAuth === 'DELETE';
        let isReduceAuth = false;
        const originalAuthIndex = this.authList.findIndex((i: any) => i.id === item.inheritAuth);
        isReduceAuth = command < originalAuthIndex && !isDeleteAuth;
        // 权限缩小or删除权限才会打破集成 需要二次弹窗，否则直接改
        if (isDeleteAuth || isReduceAuth) {
          let that = this;
          Modal.warning({
            title: intl.$t("权限变更"),
            content: intl.$t("当前页面将取消与父页面的权限关联，此后父页面的新增、删除、修改权限，均不会影响到本页面。是否继续？"),

            modalClass: 'delete_dialog',
            bodyClass: 'delete_dialog_body',
            titleAlign: 'start',
            closable: false,
            hideCancel: false,
            okText: intl.$t("确定"),
            cancelText: intl.$t("取消"),
            onOk(e) {
              that.changeAuth(command, index);
            } });

        } else {
          this.changeAuth(command, index);
        }
      } else {
        this.changeAuth(command, index);
      }
    },
    modifyAuth(command: number, index: number) {
      this.showPushMsgDialog = false;
      const fileId = this.fileId;
      /// 修改权限
      const list = [
      {
        auth: this.authList[command].id,
        to: this.memberList[index].to,
        toSpace: this.memberList[index].toSpace,
        toType: this.memberList[index].toType }];


      const pushMessage = this.memberList[index].pushMessage;
      const data = {
        fileId: fileId,
        list: list,
        pushMessage: pushMessage };

      setFileAuth(data).
      then((res: any) => {
        const { code, message } = res.data;
        if (code === 200) {
          this.memberList[index].auth = this.authList[command].id;
          this.$emit('updateMemberAuthList');
          this.$message.success(intl.$t("修改用户权限成功"));
        } else {
          this.$message.error(intl.$t("修改用户权限失败，"), message);
        }
      }).
      catch((err) => {
        this.$message.error(intl.$t("修改用户权限失败"));
      });
    },
    openAuthList(item: any, index: number) {
      this.editableFocus[index] = !this.editableFocus[index];
      if (!this.editableFocus[index]) {
        return;
      }
      if (item.memberIdentity === 'COLLABORATOR' || item.memberIdentity === 'MEMBER') {
        if (this.authList.some((item: any) => item.id === 'NONE')) {
          this.authList = this.authList.filter(
          (i: any) => i.id !== 'NONE');

        }
        if (!this.authList.some((item: any) => item.id === 'DELETE')) {
          this.authList.push({
            id: 'DELETE',
            name: intl.$t("删除协作者") });

        }
      }
      this.memberList[index].pushMessage = false;
    },
    dropdownMenuVisibleChange(visible: boolean, index: number) {
      if (!visible) {
        this.$refs.ManageCenter.style.overflowY = 'auto';
        this.editableFocus[index] = visible;
        this.editableHover[index] = visible;
      } else {
        this.$refs.ManageCenter.style.overflowY = 'hidden';
      }
    },
    mouseAction(index: number, isHover: boolean) {
      if (this.editableFocus[index] === true && !isHover) {
        this.editableHover[index] = true;
        return;
      }
      this.editableHover[index] = isHover;
    },
    changeEditableIcon(index: number) {
      return this.editableFocus[index] ?
      EditableSelectedIcon :
      this.editableHover[index] ?
      EditableHoverIcon :
      EditableIcon;
    },
    fileAvatar(item: any) {
      if (item.toType === 'PERSON' || item.toType === 'APP') {
        const userAvatar = memberAvatar.getMemberAvatar(
        item.toAvatar,
        '');

        return (
          userAvatar['100'] ??
          userAvatar['300'] ??
          userAvatar['original']);

      } else if (item.toName === intl.$t("知识库管理员")) {
        return ManagerAvatar;
      } else if (item.toType === 'GROUP') {
        if (item.toAvatar && item.toAvatar.length > 0) {
          return item.toAvatar;
        }
        return GroupAvatar;
      } else if (item.toType === 'USER_GROUP') {
        return GroupAvatar;
      } else if (
      item.toType === 'DEPARTMENT' &&
      item.toSpace !== this.spaceId)
      {
        return UnitedDepartmentAvatar;
      } else {
        return DepartmentAvatar;
      }
    },
    avatarColorStye(name: string | null) {
      if (!name) {
        return `background-color: #5C70FF`;
      }
      let avatarColor = nameColor.getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name: string | null) {
      if (!name) {
        return intl.$t("未知");
      }
      return nameColor.getLastName(name);
    } } };
</script>

<style lang="scss" scoped>
.file-manage-view {
    display: flex;
    flex-direction: column;
    flex: 1;

    .file-manage-content {
        display: flex;
        flex-direction: column;
        flex: 1;

        .file-manage-center {
            display: flex;
            flex-direction: column;
            overflow-x: hidden;
            overflow-y: auto;
            min-height: 40px;
            max-height: 200px;

            &::-webkit-scrollbar {
                display: none;
            }

            .file-manage-worker-item {
                width: 100%;
                height: 40px;
                margin-bottom: 4px;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                flex-shrink: 0;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9;
                    border-radius: 8px;
                }

                .worker-avatar {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 32px;
                    height: 32px;
                    border-radius: 8px;
                    margin-right: 12px;
                    margin-left: 4px;

                    img {
                        width: 32px;
                        height: 32px;
                        border-radius: 8px;
                    }

                    .user-avatar {
                        width: 32px;
                        height: 32px;
                        border-radius: 8px;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .user-name {
                            font-weight: 600;
                            font-size: 12px;
                            color: #ffffff;
                            letter-spacing: 0;
                            line-height: 17px;
                        }
                    }
                }

                .worker-info {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    justify-content: space-between;
                    flex: 1;
                    height: 40px;
                    margin-right: 4px;

                    .worker-title {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                        height: 100%;

                        .worker-name {
                            font-family: PingFangSC-Regular;
                            font-weight: 300;
                            font-size: 14px;
                            color: #323233;
                            letter-spacing: 0;
                            line-height: 20px;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            overflow: hidden;
                        }

                        .worker-space-name {
                            margin-left: 4px;
                            color: #fc7d29;
                            font-family: PingFangSC-Regular;
                            font-weight: 300;
                            font-size: 14px;
                            letter-spacing: 0;
                            line-height: 20px;
                            display: flex;
                            flex-shrink: 0;
                        }

                        .worker-tag-app {
                            background-color: #fff1ee !important;
                            color: #f05f11 !important;
                        }

                        .worker-tag {
                            height: 18px;
                            padding: 0 4px;
                            margin-left: 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 4px;
                            background-color: #eef0ff;
                            font-family: PingFangSC-Medium;
                            font-weight: 500;
                            font-size: 10px;
                            color: #5c70ff;
                            letter-spacing: 0;
                            line-height: 14px;
                        }

                        .worker-recover {
                            font-size: 12px;
                            color: #fba724;
                            margin-left: 8px;
                            display: flex;
                            flex-shrink: 0;
                        }
                    }

                    .worker-wiki-role {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #a2a4b0;
                        letter-spacing: 0;
                        line-height: 20px;
                    }
                }

                .worker-auth-diseditable {
                    font-family: PingFangSC-Regular;
                    font-weight: 300;
                    font-size: 14px;
                    color: #222329;
                    letter-spacing: 0;
                    line-height: 20px;
                    margin-right: 8px;
                }

                .worker-auth-editable {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    height: 32px;
                    margin-right: 8px;
                    font-family: PingFangSC-Regular;
                    font-weight: 300;
                    font-size: 14px;
                    color: #222329;
                    letter-spacing: 0;
                    text-align: center;
                    line-height: 20px;
                    border: none;
                    background-color: transparent;
                    cursor: pointer;

                    &:hover {
                        color: #5c70ff;
                    }

                    img {
                        margin-left: 4px;
                        width: 10px;
                        height: 10px;
                        object-fit: contain;
                    }

                    .editable-icon {
                        margin-left: 4px;
                        width: 10px;
                        height: 10px;
                    }
                }
            }

            .file-manage-scrollbar {
                position: absolute;
                right: 4px;
                top: 0;
                width: 4px;
                background-color: #dcddde;
                border-radius: 3px;
                transition: opacity 0.2s ease-in-out;

                &.hide {
                    opacity: 0;
                }
            }
        }
    }
}

// .custom_tooltip_css {
//     border-radius: 8px;
//     color: #767c85;
//     font-size: 14px;
//     font-weight: 400;
//     padding: 8px;
//     background-color: #ffffff;
//     box-shadow: 0 8px 12px 0 #1213171a !important;
// }

// .custom_tooltip_css_arrow {
//     background-color: transparent;
// }
</style>

<style lang="scss">
@import './theme/commonDialog.scss';

.dropdown-auth-editable {
    z-index: 3001 !important;

    .arco-dropdown {
        margin-right: 8px !important;
        padding: 0 !important;
        background: #ffffff !important;
        border: 1px solid #e6e8ec !important;
        box-shadow: 0 8px 12px 0 #1213171a !important;
        border-radius: 8px !important;
        width: 258px !important;

        .arco-dropdown-list-wrapper {
            max-height: none !important;

            .arco-dropdown-option {
                min-height: 28px !important;
                padding: 0 0 !important;
                margin: 4px 4px 4px 4px !important;
                display: flex !important;
                flex-direction: column !important;
                align-items: flex-start !important;
                justify-content: center !important;
                line-height: 100% !important;
                width: inherit !important;
                cursor: pointer;

                &:hover {
                    background-color: #f4f6f9 !important;
                    border-radius: 8px !important;
                }

                .arco-dropdown-option-content {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .auth-name {
                        font-size: 14px !important;
                        font-weight: 500 !important;
                        font-family: PingFangSC-Regular !important;
                        color: #222329 !important;
                        line-height: 20px;
                        margin-top: 4px;

                        img {
                            width: 15px;
                            height: 11px;
                            margin: 0 11px;
                        }
                    }

                    .auth-desc {
                        font-family: PingFangSC-Regular;
                        font-weight: 400;
                        font-size: 12px;
                        color: #a5a7b3;
                        letter-spacing: 0;
                        line-height: 17px;
                        margin: 0 16px 4px 36px;
                        white-space: pre-wrap !important;
                        word-wrap: break-word;
                    }
                }
            }

            .push-message {
                height: 28px;
                padding: 4px 16px 0 36px;
                margin: 4px;
                border-top: 1px solid #f1f4f5;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                span {
                    flex: 1;
                    font-size: 14px;
                    font-weight: 300;
                    font-family: PingFangSC-Regular;
                    line-height: 20px;
                    transition: color 0.2s ease-in-out;
                }
            }
        }

        .arco-scrollbar-track {
            display: none;
        }
    }
}
</style>
